export default __webpack_public_path__ + "static/15-31525c8458d86f8460c2a9a0b338aced.jpg";